var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _path7, _path8, _path9, _g4, _path10, _path11, _g5, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSmallScreenView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 40,
    viewBox: "0 0 134 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1226_4210",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 9,
    width: 10,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0623 9.33325H11.2637V30.6495H20.0623V9.33325Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1226_4210)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1226_4210",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 9,
    width: 10,
    height: 22
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0623 9.33325H11.2637V30.6495H20.0623V9.33325Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1226_4210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2637 9.33325V30.6666L20.0623 15.6068L11.2637 9.33325Z",
    fill: "#1799D5"
  }))))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1226_4210",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 9,
    width: 10,
    height: 22
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1689 9.33325H32.3702V30.6495H41.1689V9.33325Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1226_4210)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1226_4210",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 9,
    width: 10,
    height: 22
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1689 9.33325H32.3702V30.6495H41.1689V9.33325Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1226_4210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.3702 15.6068L41.1518 30.6666V9.33325L32.3702 15.6068Z",
    fill: "#1799D5"
  }))))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1226_4210",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 5,
    width: 13,
    height: 15
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3702 5.0769H20.0623V20H32.3702V5.0769Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1226_4210)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1226_4210",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 5,
    width: 13,
    height: 15
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3702 5.0769H20.0623V20H32.3702V5.0769Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1226_4210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.3702 15.6068L26.2077 5.0769L20.0623 15.6068L26.2077 20L32.3702 15.6068Z",
    fill: "#1799D5"
  }))))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2637 30.6667H41.1518L26.2077 20L11.2637 30.6667Z",
    fill: "#1799D5"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1226_4210",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 15,
    width: 16,
    height: 16
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1517 15.6069H26.2077V30.6497H41.1517V15.6069Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1226_4210)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1226_4210",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 15,
    width: 16,
    height: 16
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1517 15.6069H26.2077V30.6497H41.1517V15.6069Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1226_4210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2077 20.0001L41.1517 30.6668L32.3702 15.6069L26.2077 20.0001Z",
    fill: "#1799D5"
  }))))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1226_4210",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 15,
    width: 16,
    height: 16
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2077 15.6069H11.2637V30.6497H26.2077V15.6069Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1226_4210)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1226_4210",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 15,
    width: 16,
    height: 16
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2077 15.6069H11.2637V30.6497H26.2077V15.6069Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1226_4210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0623 15.6069L11.2637 30.6668L26.2077 20.0001L20.0623 15.6069Z",
    fill: "#1799D5"
  }))))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1518 32.7864H11.2637V34.9231H41.1518V32.7864Z",
    fill: "#1799D5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2985 1.74365H52.4155V38.2565H54.2985V1.74365Z",
    fill: "#CBD2DD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M74.977 24.3077H68.7118L67.2054 28.8718H63.8674L70.1497 11.0427H73.5391L79.8214 28.8718H76.4834L74.977 24.3077ZM71.8444 14.1367C71.8444 14.1367 71.4335 15.8974 71.0912 16.906L69.4992 21.6752H74.1724L72.5805 16.906C72.2552 15.8974 71.8786 14.1367 71.8786 14.1367H71.8273H71.8444Z",
    fill: "#15284B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4476 11.0427H84.6144V24.4102C84.6144 25.812 85.0937 26.1709 85.9154 26.1709C86.7371 26.1709 86.3947 26.1538 86.3947 26.1538V28.9402C86.3947 28.9402 85.9154 29.0085 85.3847 29.0085C83.6216 29.0085 81.4305 28.5641 81.4305 24.8889V11.0598L81.4476 11.0427Z",
    fill: "#15284B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M88.757 11.0427H91.9239V13.8803H88.757V11.0427ZM88.757 16.0684H91.9581V28.8718H88.757V16.0684Z",
    fill: "#15284B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M100.329 31.436C102.297 31.436 103.958 30.6154 103.958 28.3248V27.5727C103.958 27.265 104.009 26.8889 104.009 26.8889H103.958C103.205 28.0172 102.092 28.6154 100.38 28.6154C96.7169 28.6154 94.6285 25.6582 94.6285 22.1368C94.6285 18.6154 96.6142 15.7607 100.312 15.7607C104.009 15.7607 104.112 17.3847 104.112 17.3847H104.18C104.18 17.3847 104.163 17.2308 104.163 17.0257V16.0513H107.159V28.0855C107.159 32.4787 103.735 34.1368 100.397 34.1368C97.0592 34.1368 97.0764 33.6924 95.8439 33.0257L96.8025 30.5813C96.8025 30.5813 98.4116 31.4018 100.346 31.4018L100.329 31.436ZM104.026 22.171C104.026 19.265 102.588 18.4787 100.859 18.4787C99.1305 18.4787 97.8467 19.8804 97.8467 22.0513C97.8467 24.2223 99.0107 25.9488 101.065 25.9488C103.119 25.9488 104.026 25.077 104.026 22.1881V22.171Z",
    fill: "#15284B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M110.668 16.0684H113.732V17.5556C113.732 18.0342 113.681 18.4274 113.681 18.4274H113.732C114.28 17.3505 115.701 15.7607 118.286 15.7607C120.87 15.7607 122.736 17.2479 122.736 20.6325V28.8719H119.569V21.2821C119.569 19.7266 119.176 18.6667 117.532 18.6667C115.889 18.6667 114.571 19.7436 114.092 21.2821C113.921 21.812 113.869 22.3932 113.869 22.9915V28.8719H110.668V16.0684Z",
    fill: "#15284B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmallScreenView);
export default __webpack_public_path__ + "static/media/logo_small_screen_view.ca6ae305d08c08f1d25389b5f2fbd4a8.svg";
export { ForwardRef as ReactComponent };